<template>
  <v-list>
    <v-list-item-title class="text-h6">{{
      selectedClient.fullName
    }}</v-list-item-title>
    <v-list-item-subtitle
      >DOB: {{ selectedClient.formattedDobLong }}</v-list-item-subtitle
    >
    <v-divider class="my-2"></v-divider>
    <v-list-item-subtitle>
      Report Type: <span class="font-weight-bold">{{ reportTypeName }}</span>
    </v-list-item-subtitle>
    <v-list-item-subtitle>
      Template: <span class="font-weight-bold">{{ templateName }}</span>
    </v-list-item-subtitle>
    <v-list-item-subtitle v-if="isAdmin">
      Provider: <span class="font-weight-bold">{{ providerName }}</span>
    </v-list-item-subtitle>
    <v-list-item-subtitle>
      Status:
      <status-chip
        :reportAssignment="templateNote.reportAssignment"
      ></status-chip>
    </v-list-item-subtitle>
  </v-list>
</template>
<script>
import StatusChip from "../ReportAssignments/status-chip.vue";
export default {
  components: {
    StatusChip,
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    templateNote() {
      return this.$store.state.notesModule.selectedTemplateNote;
    },
    selectedClient() {
      return this.templateNote?.client;
    },
    selectedTemplate() {
      return this.templateNote?.template;
    },
    reportTypeName() {
      return this.templateNote?.reportAssignment?.reportType?.name;
    },
    templateName() {
      return this.selectedTemplate?.name;
    },
    providerName() {
      return this.templateNote?.providerName;
    },
  },
};
</script>
